import { Shark } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

import templateContent from "Templates/views/verify-vehicle.html";
import { refuelEditView } from "./refuelEditView";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";

var verifyVehicleView = Shark.createJaw("verifyVehicleView");

verifyVehicleView.templateContent = templateContent;
verifyVehicleView.route = "vehicle-pickup";

verifyVehicleView.addMethod("init", function () {
    this.addComponents([mainNavComponent]);
});

// verifyVehicleView.addMethod("newRefuelBtn_clickHandler", function () {
//     Shark.openPage(refuelEditView);
// });


Shark.registerView(verifyVehicleView);

export { verifyVehicleView };
